<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">

         <div class="lg:mb-4 mt-4" v-if="form.Guid">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.guid')}}
                <el-form-item prop="Guid">
                  <el-input
                    disabled
                    class="w-full"
                    v-model="form.Guid"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.clientid')}}
                <el-form-item prop="ClientId">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.ClientId"
                    maxlength='50'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.tenantid')}}
                <el-form-item prop="TenantId">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.TenantId"
                    maxlength='50'
                  />
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.config_aad_secret')}}
                <el-form-item prop="ClientSecret">
                  <el-input
                    ref="passwordInputClientSecret"
                    :disabled="disableEditPass"
                    clearable
                    show-password
                    class="w-full"
                    v-model="form.ClientSecret"
                    autocomplete="new-password"
                    maxlength='100'
                  >
                    <base-button-icon
                      v-if="visibleEditPass"
                      slot="append" 
                      @click="editSmtpPassToggle()"
                      :name="disableEditPass ? 'editpencil' : 'cross'"
                      :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                      iconSize="md"
                      size="xs"
                      mode="primary-phantom"
                      class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                    />
                  </el-input>
                </el-form-item>
              </label>
            </div>
          </div>

          <div class="mb-4">
            <div class="mandatory">
              <label for="switch-aad-sync" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.config_aad_sync')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="switch-aad-sync"
                :aria-label="$t('clients.config_aad_sync')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.AadSync" 
                :active-text="$t('companies.active')"/>
            </div>
          </div>

           <base-collapsible-form 
              v-if="visibleGruposRoles"
              ref="baseCollapsibleGruposRoles" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex items-center mt-4 mb-4">
                  <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_aad_grupos_roles')}}</h2>
                </div>
              </template>
              <template slot="content">
                <el-table
                ref="whitelistmetadata"
                :data="formUnwatchable.ListaGruposRoles"
                style="width: 100%"
                max-height="250">
                <el-table-column
                  prop="Nombre"
                  label="Nombre del grupo (Azure)"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="Rol"
                  label="Rol (EdasNEO)"
                  show-overflow-tooltip
                  >
                </el-table-column>
                <el-table-column
                  prop="actions"
                  width="120"
                  align="center"
                  label="Acciones">
                  <template slot-scope="scope">
                  <div class="flex flex-row justify-end">
                    <base-button-icon @click="deleteGrupoRol(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar registro"/>
                  </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="w-full float-right">
                <base-button-responsive
                  mode="primary"
                  :text="$t('clients.config_aad_grupos_roles_new')"
                  @click="newGrupoRolToggleDialog()"
                  icon="plus"
                  class="m-5 float-right"
                />
              </div>
              </template>
            </base-collapsible-form>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <input-add-grupo-rol-dialog
        :dialogOpen="showModalGrupoRol" 
        @toggleDialog="newGrupoRolToggleDialog" 
        @applyDialog="applyNewGrupoRolDialog"
        header="Añadir nueva relación de grupo y rol" 
        />
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '../../components/layout/DetailLayout.vue'
import { getClient } from '@/services/clients/getClient'
import { getconfigaad } from '@/services/clients/getconfigaad' 
import { updateconfigaad } from '@/services/clients/updateconfigaad' 
import { getgruposrolesconfigaad } from '@/services/clients/getgruposrolesconfigaad' 
import { agregarconfigaadrolgrupo } from '@/services/clients/agregarconfigaadrolgrupo' 
import { eliminarconfigaadrolgrupo } from '@/services/clients/eliminarconfigaadrolgrupo' 
import { i18n } from '@/i18n'

import InputAddGrupoRolDialog from '@/components/InputAddGrupoRolDialog.vue'

export default {
  /* eslint-disable camelcase */
  name: 'config-aad-detail',
  components: {
    DetailLayout,
    InputAddGrupoRolDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.config_aad'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/clients/details'
      },
      visibleGruposRoles: false,
      showModalGrupoRol: false,
      formUnwatchable: {
        ListaGruposRoles: []
      },
      form: {
        Guid: '',
        TenantId: '',
        ClientId: '',
        ClientSecret: '',
        AadSync: false,
        HasPass: false,
      },
      visibleEditPass: true,
      disableEditPass: true,
      rules: {
        TenantId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        ClientId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      name: this.$i18n.t('app.configurations')
    })
    breadcrumbs.push({
      path: 'configurations/clients',
      name: this.$i18n.t('app.clients')
    })
    if (this.id !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.downloadListGruposRoles()
    this.setData(data.respuesta)
  },
  mounted () {
    this.resetControlFormChanges()

    this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
      setTimeout(() => {
        this.fixAccesibilityElInputPassword(this.$refs.passwordInputClientSecret, this.$i18n.t('aria.elementui.input.password'))
      }, 1000)
    })
  },
  methods: {
    applyNewGrupoRolDialog: async function (grupoRol) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          NombreGrupo: grupoRol.value, 
          idRol: grupoRol.rol,
          idCliente: this.id,
        }
        const response = await agregarconfigaadrolgrupo(null, payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newGrupoRolToggleDialog()
          this.downloadListGruposRoles()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteGrupoRol: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { NombreGrupo: row.Nombre, idCliente: this.id }
        const response = await eliminarconfigaadrolgrupo(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListGruposRoles()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListGruposRoles: async function () {
      try {
        const payload = { idCliente: this.id ?? -1 }
        const result = await getgruposrolesconfigaad(payload)
        if (result.blnError) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaGruposRoles = result.respuesta
            .map(x => ({ Nombre: x.NombreGrupo, Rol: x.Rol }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    newGrupoRolToggleDialog () {
      this.showModalGrupoRol = !this.showModalGrupoRol
    },
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.ClientSecret = ''
      else this.form.ClientSecret = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    submitForm: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idCliente: this.id,
          TenantID: this.form.TenantId,
          ClientID: this.form.ClientId,
          ClientSecret: this.form.ClientSecret,
          SincronizarRolesAAD: this.form.AadSync,
          TieneClientSecret: !this.disableEditPass,
        }
        const response = await updateconfigaad(null, payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Datos actualizados correctamente', 'success')
          const data = await this.downloadData(this.id)
          this.setData(data.respuesta)
          this.resetControlFormChanges()
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/clients/details', params: this.id })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = await getconfigaad({ idCliente: id })
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          return data
        }
        return data
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        this.form.Guid = data.Guid ? data.Guid : null
        this.form.ClientId = data.ClientID ? data.ClientID : null
        this.form.TenantId = data.TenantID ? data.TenantID : null
        this.form.AadSync = data.SincronizarRolesAAD ? data.SincronizarRolesAAD : null
        this.form.HasPass = data.TieneClientSecret ? data.TieneClientSecret : null
        if (data.TieneClientSecret) {
          this.form.ClientSecret = '**********'
          this.visibleEditPass = true
          this.disableEditPass = true
        } else {
          this.visibleEditPass = false
          this.disableEditPass = false
        }
        if (data.ClientID && data.TenantID) {
          this.visibleGruposRoles = true
        } else {
          this.visibleGruposRoles = false
        }
      }
      this.resetControlFormChanges()
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
